export enum ImportTabs {
    All = 'all',
    Suppliers = 'suppliers',
}
